import Head from './Head';
import HeadContainer from './Head.container';

export default HeadContainer(Head);
